import React, { useContext, useEffect, useState } from "react";

import { Grid } from "@material-ui/core";
import {
  InputOptionMaster,
  InputTextArea,
  InputTextMaster,
} from "App/Component/ui";
import { FormContext } from "../../context/FormContext";
import { TYPE_INSTANCE4 } from "App/constants";
import { useInitialMasterSupplier, useSelectOption } from "App/hooks";
import DatePicker from "react-datepicker";
import moment from "moment";
import Perhitungan from "../Perhitungan/Perhitungan";
import ModalListRequest from "../ModalListRequest";
import { SearchIcon } from "App/Assets";
import { isNull, today } from "App/utils/helpers";
export default function FormPo({ setListPO, listPO, setNewDataPoList }) {
  const { formData, setFormData, rowsSelect } = useContext(FormContext);
  const [showModalListRequest, setShowModalListRequest] = useState(false);

  const produsen = useSelectOption(
    false,
    "/wmsMasterAsset/master/list-produsen",
    TYPE_INSTANCE4
  );

  const supplier = useInitialMasterSupplier(
    true,
    "/wmsMasterAsset/master/list-supplier"
  );

  const unit = useSelectOption(
    true,
    "/wmsmaster/unit/read_gudang_farmasi",
    TYPE_INSTANCE4
  );

  const handleChange = (text) => (e) => {
    setFormData({
      ...formData,
      [text]: e.target.value,
    });
  };

  const changeSelectWithLocalStorage = (e, name_id, name_label) => {
    setFormData({
      ...formData,
      [name_id]: e?.value,
      [name_label]: e?.label,
    });
  };

  useEffect(() => {
    setFormData({
      ...formData,
      date: moment(new Date()).local().toDate(),
    });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const handleClickSelect = async (row) => {
    setFormData({
      ...formData,
      idreq: row?.id,
      idpo: "",
      date: today(),

      unit_id: row?.unit_id,
      unit: row?.unit,

      supplier_id: null,
      supplier: "Pilih Supplier",

      penerima: "",
      // remark: row?.remark,
      remark: "",
      nomorPo: "",

      type: "create",
      status: 0,

      isOpenDraf: false,
      isProcess: false,
      isRequest: true,

      jumlah: 0,
      tax: 0,
      total_jumlah: 0,
      listpo: [],
      status_transaksi: 0,
      catatan_proses: "",
    });
    setListPO([]);
    setShowModalListRequest(false);
  };

  return (
    <>
      {showModalListRequest && (
        <ModalListRequest
          setShowModal={() => setShowModalListRequest(false)}
          handleClickSelect={handleClickSelect}
          onlySelect={false}
        />
      )}
      <Grid container spacing={3}>
        <Grid item sm={6}>
          <form action="">
            <Grid container spacing={1}>
              <Grid item sm={6}>
                {isNull(formData.idpo) ? (
                  <InputTextMaster
                    name="id"
                    label="ID / ID REQUEST"
                    id="id"
                    placeholder={"Cari Request"}
                    disabled={true}
                    value={
                      formData?.isRequest ? formData?.idreq+" ( "+rowsSelect.length+" Barang Terpilih)" : formData.idpo
                    }
                    withButton={true}
                  >
                    <button
                      type={"button"}
                      onClick={() =>
                        setShowModalListRequest(!showModalListRequest)
                      }
                      style={{
                        borderRight: "1px solid #EAEAEA",
                        borderTop: "1px solid #EAEAEA",
                        borderBottom: "1px solid #EAEAEA",
                        borderLeft: "0",
                        background: "#fff",
                        padding: "0 0.8rem",
                        cursor: "pointer",
                        borderRadius: "0 6px 6px 0",
                      }}
                    >
                      <SearchIcon width={"16"} height={"16"} fill={"#333"} />
                    </button>
                  </InputTextMaster>
                ) : (
                  <InputTextMaster
                    name="id"
                    label="ID Request / ID PO"
                    id="id"
                    value={
                      isNull(formData.idpo) ? formData.idreq : formData.idpo
                    }
                    placeholder={"-"}
                    disabled={true}
                    withButton={false}
                  />
                )}{" "}
              </Grid>

              <Grid item sm={6}>
                <InputTextMaster
                  name="id"
                  label="NO. PURCHASE ORDER"
                  id="id"
                  placeholder="-"
                  disabled={true}
                  value={formData.nomorPo}
                />
              </Grid>

              <Grid item sm={4}>
                <InputOptionMaster
                  name="unit_id"
                  label="UNIT"
                  id="unit_id"
                  withSearch={true}
                  disabled={formData.isRequest ? true : formData.isProcess}
                  data={unit}
                  value={formData.unit_id}
                  labelValue={formData.unit}
                  onChange={(e) =>
                    changeSelectWithLocalStorage(e, "unit_id", "unit")
                  }
                />
              </Grid>
              <Grid item sm={4}>
            <InputOptionMaster
              name="produsen_id"
              label="PRODUSEN"
              id="produsen_id"
              withSearch={true}
              disabled={formData.isProcess}
              data={produsen}
              value={formData.produsen_id}
              labelValue={formData.produsen}
              onChange={(e) => {
                if (isNull(e)) {
                  setFormData({
                    ...formData,
                    produsen_id: null,
                    produsen: "Pilih Produsen",
                  });
                } else {
                  setFormData({
                  ...formData,
                  produsen_id: e?.value,
                  produsen: e?.label,
                })
                }
              }}
            />
          </Grid>
              <Grid item sm={4}>
                <InputOptionMaster
                  name="supplier_id"
                  label="SUPPLIER"
                  id="supplier_id"
                  withSearch={true}
                  disabled={formData.isProcess}
                  data={supplier}
                  value={formData.supplier_id}
                  labelValue={formData.supplier}
                  onChange={(e) =>
                    changeSelectWithLocalStorage(e, "supplier_id", "supplier")
                  }
                />
              </Grid>

              <Grid item sm={6}>
                <div
                  style={{
                    marginTop: "0.5rem",
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  <label htmlFor="date" className="form-control-label">
                    TANGGAL
                  </label>

                  <div
                    onClick={() =>
                      setFormData({
                        ...formData,
                        date: moment(new Date()).local().toDate(),
                      })
                    }
                    style={{
                      fontSize: "10px",
                      color: "#3399ff",
                      cursor: "pointer",
                    }}
                  >
                    Today
                  </div>
                </div>
                <DatePicker
                  id="date"
                  autoComplete="off"
                  className="form-control text"
                  dateFormat="dd/MM/yyyy HH:mm"
                  timeFormat="HH:mm"
                  showTimeSelect
                  timeIntervals={5}
                  disabled={formData.isProcess}

                  locale="id-ID"
                  selected={moment(formData.date).toDate()}
                  onChange={(e) => {
                    setFormData({
                      ...formData,
                      date: e,
                    });
                  }}
                  placeholderText="Tanggal"
                />
              </Grid>

              <Grid item sm={6}>
                <InputTextMaster
                  name="penerima"
                  label="PENERIMA"
                  disabled={formData.isProcess}
                  id="penerima"
                  placeholder="Penerima"
                  value={formData.penerima}
                  onChange={handleChange("penerima")}
                />
              </Grid>

              <Grid item sm={12}>
                <InputTextArea
                  name="remark"
                  label="CATATAN SURAT PURCHASE ORDER"
                  id="remark"
                  disabled={formData.isProcess}
                  placeholder="Catatan"
                  rows={3}
                  value={formData.remark}
                  onChange={handleChange("remark")}
                />
              </Grid>
            </Grid>
          </form>
        </Grid>

        <Grid item sm={6}>
          <Perhitungan
            setListPO={setListPO}
            listPO={listPO}
            // perhitungan={perhitungan}
            setNewDataPoList={setNewDataPoList}
          />
        </Grid>
      </Grid>
    </>
  );
}
